export default __webpack_public_path__ + "static/media/daisy.e97c84df.svg";